const TITLE_IMAGE_NAME = "title-image";
const TITLE_IMAGE_FILE_TYPE = ".png";
const LOGO_IMAGE_NAME = "logo";
const PROFILE_IMAGE_NAME = "profile-image";

export const useConfig = () => ({
  TITLE_IMAGE_NAME,
  TITLE_IMAGE_FILE_TYPE,
  LOGO_IMAGE_NAME,
  PROFILE_IMAGE_NAME
});
